<template>
  <in-viewport>
    <div class="contact-section">
      <base-layout hide-sidebar>
        <border-box slot="sidebar"><h2 v-html="heading"/></border-box>
        <div slot="content">
          <grid-row>
            <div class="contact-section__item">
              <border-box>
                <h3 class="contact-section__heading">{{ $t('companyAddress') }}:</h3>
                <ul class="contact-section__list">
                  <li><strong>SAWAWA Sp. z o.o.</strong></li>
                  <li>{{ $t('companyStreetAddress') }}</li>
                  <li>{{ $t('companyStreetAddressAdditional') }}</li>
                  <li>00-582 Warszawa</li>
                </ul>

                <h3 class="contact-section__heading">{{ $t('companyInformation') }}:</h3>
                <ul class="contact-section__list">
                  <li><strong>NIP</strong> 5213704070</li>
                  <li><strong>KRS</strong> 0000571858</li>
                  <li><strong>REGON</strong> 362301830</li>
                </ul>
              </border-box>
            </div>
            <div class="contact-section__item">
              <border-box class="align-to-end" xs-hide>
                <h3 class="contact-section__heading">{{ $t('contact') }}:</h3>
                <ul class="contact-section__list">
                  <li>
                    <a href="tel:+48222438008" class="contact-section__link">
                      +48 22 243 80 08
                    </a>
                  </li>
                  <!--<li>
                    <a href="tel:+48601090682" class="contact-section__link">
                      +48 601 090 682
                    </a>
                  </li>-->
                  <li>
                    <a href="mailto:biuro@sawawa.com.pl" class="contact-section__link">
                      biuro@sawawa.com.pl
                    </a>
                  </li>
                </ul>
              </border-box>
            </div>
          </grid-row>
        </div>
      </base-layout>
    </div>
  </in-viewport>
</template>

<script>
import BaseLayout from '@/components/BaseLayout'
import BorderBox from '@/components/BorderBox'

export default {
  components: {
    BaseLayout,
    BorderBox
  },
  props: {
    heading: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .contact-section {
    @include vertical-space((bottom: 1), padding);

    &__list {
      @include reset-list;
      @include text(big, medium);
      @include vertical-space((bottom: 1), padding);
    }

    &__link {
      @include reset-link;
      transition: color $base-transition;

      &:hover {
        @include theme-opposite(color);
      }
    }

    &__heading {
      @include text;
      line-height: 2 * $vertical-space;

      @include media-up(lg) {
        margin-top: 4px;
      }
    }

    &__item {
      @include grid-column((xs: 12, md: 6));

      &:nth-child(odd) {
        @include media-up(lg) {
          @include nested-column-width(4, 9, lg);
        }
      }

      &:nth-child(even) {
        @include media-up(lg) {
          @include nested-column-width(5, 9, lg);
        }
      }
    }
  }

  .align-to-end {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
</style>



// WEBPACK FOOTER //
// src/containers/Contact/ContactSection.vue